import { GoogleTagAnalyticsService } from '@/app/services/google-tag';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
  signal,
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EGoogleTagAnalyticsKeys } from '../../../enums';
import { EMatchTap } from '../../models';

interface ITapOption {
  title: string;
  isSelected: boolean;
  value: EMatchTap;
}

const matchTap = {
  0: 'SUMMARY',
  1: 'STATS',
  2: 'LINEUP',
  3: 'INFO_MATCH',
};

@Component({
  selector: 'app-match-tab-bar',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './match-tab-bar.component.html',
  styleUrl: '../../../../../../styles/tab-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatchHeaderTabBarComponent {
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);
  valueTap = output<EMatchTap>();

  selectedTap = signal<EMatchTap>(EMatchTap.SUMMARY);
  tapOption = computed<ITapOption[]>(
    () =>
      [
        {
          title: this.translateService.instant('Summary'),
          isSelected: true,
          value: EMatchTap.SUMMARY,
        },
        {
          title: this.translateService.instant('Statics'),
          isSelected: false,
          value: EMatchTap.STATS,
        },
        {
          title: this.translateService.instant('Lineup'),
          isSelected: false,
          value: EMatchTap.LINEUP,
        },
        {
          title: this.translateService.instant('MatchInfo'),
          isSelected: false,
          value: EMatchTap.INFO_MATCH,
        },
      ].filter(Boolean) as ITapOption[]
  );

  displayedTapOptions = computed(() =>
    this.tapOption().map((item) => ({
      ...item,
      isSelected: item.value === this.selectedTap(),
    }))
  );

  constructor(private readonly translateService: TranslateService) {}

  handleSetTap = (value: EMatchTap) => {
    // google tag
    this.googleTagAnalyticsService.event(
      EGoogleTagAnalyticsKeys.MATCH_DETAILS_MATCH_ODL_TAB,
      {
        tab: matchTap[value] ?? this.selectedTap(),
      }
    );

    this.selectedTap.set(value);
    this.valueTap.emit(value);
  };
}
